import { gql } from '@apollo/client';

const GET_USER = gql`
  query getUser($id: String!) {
    user: getUser(id: $id) {
      id
      shopwareId
      shopwareProperties {
        companyId
        company
        email
        firstname
        lastname
        title
        jobTitle
        tel
        industry
        industryName
        creditApprovedOnline
        viewPricingOnline
      }
    }
  }
`;

const GET_INDUSTRIES = gql`
  query getIndustries {
    industries: getIndustries(sort: [{ property: "name", direction: "asc" }]) {
      id
      name
    }
  }
`;

const GET_COUNTRIES = gql`
  query getCountries($includeOldId: Boolean) {
    countries: getCountries(
      sort: [{ property: "name", direction: "asc" }]
      includeOldId: $includeOldId
    ) {
      id
      name
      code
      oldId
    }
  }
`;

const GET_TITLES = gql`
  query getTitles {
    titles: getTitles {
      id
      name
    }
  }
`;

const GET_COUNTIES_BY_COUNTRY_ID = gql`
  query getCounties($countryId: String!) {
    counties: getCounties(
      where: { countryId: $countryId }
      sort: [{ property: "name", direction: "asc" }]
    ) {
      code
      name
      countryId
      country {
        code
        name
      }
    }
  }
`;

const GET_PAGE_WITH_BRANDS = gql`
  query getPublishedPage($id: String!) {
    pageData: getPublishedPage(id: $id) {
      __typename
      id
      name
      brandIds
    }
  }
`;

const getPageQuery = entity => {
  const capitalized = entity.charAt(0).toUpperCase() + entity.slice(1);
  return gql`
  query getRecordData($id: String!) {
    pageData: getPublished${capitalized}(id: $id) {
      __typename
      id
      name
      brandIds
    }
  }
`;
};

const GET_SEARCH_PUBLISHED_CONTENT = gql`
  query searchPublishedContent(
    $rawQueryStringified: String!
    $offset: Int
    $limit: Int
    $sort: String
  ) {
    searchPublishedContent(
      rawQueryStringified: $rawQueryStringified
      offset: $offset
      limit: $limit
      sort: $sort
    ) {
      rawResults
    }
  }
`;

const GET_PRODUCT_TYPES = gql`
  query getProductTypes(
    $where: JSON!
    $offset: Int
    $limit: Int
    $sort: [GetProductTypesSortItem]
  ) {
    productTypes: getProductTypes(where: $where, offset: $offset, limit: $limit, sort: $sort) {
      id
      name
      url
      image {
        id
        url
        name
      }
    }
  }
`;

const GET_BRANDS = gql`
  query getProductTypes($where: JSON!, $offset: Int, $limit: Int, $sort: [GetBrandsSortItem]) {
    brands: getBrands(where: $where, offset: $offset, limit: $limit, sort: $sort) {
      id
      name
      url
      image {
        id
        url
        name
      }
    }
  }
`;

const GET_ACCOUNT_USER = gql`
  query getUser($id: String!) {
    user: getUser(id: $id) {
      id
      userDetails {
        firstname
        lastname
        company
        jobTitle
        email
        tel
        address
      }
    }
  }
`;

// shopwareProperties {
//   email
//   tel
// }

export {
  GET_ACCOUNT_USER,
  GET_USER,
  GET_COUNTRIES,
  GET_TITLES,
  GET_COUNTIES_BY_COUNTRY_ID,
  GET_INDUSTRIES,
  GET_PAGE_WITH_BRANDS,
  GET_PRODUCT_TYPES,
  GET_SEARCH_PUBLISHED_CONTENT,
  GET_BRANDS,
  getPageQuery
};
